import styled from "styled-components";

export const LogoStyled = styled.div`
  height: 64px;
  background-color: var(--veloprime-bg-primary);
  &.sidebarExt {
    .ant-image {
      margin: 0;
      .ant-image-img {
        height: 30px;
        width: 25px;
      }
    }
  }
  &.sidebar {
    .ant-image {
      margin: 0;
      .ant-image-img {
        height: 30px;
        width: 150px;
      }
    }
  }
  .ant-image {
    height: 64px;
    margin: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    .ant-image-img {
      height: 32px;
    }
  }

  &.mobile {
    background-color: var(--white);
    .ant-image {
      margin: 0 8px;
    }
  }

  @media only screen and (max-device-width: 812px) {
    .ant-image {
      .ant-image-img {
        margin: 0px;
        max-width: 40px;
      }
    }
  }
`;
